import Box from '@mui/material/Box';
import ContactFormPro from '../components/ContactFormPro';

import '../css/contact.scss';

const ContactPro = () => {

  return (
    <Box id="contact">
      <div id="title">
        <h1>CONTACT POUR PROFESSIONELS</h1>
      </div>
      <Box className="jumbo"
      sx={(theme) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#6F6F6F' : '#EFEFEF',
        color: '#CA8E4C',
      })}>
        <div className="flex content-width">
          <div className="jumbo-left">
            <p className="footer-phone"><span className="icon phone-out" /> 0473/19.94.70</p>
              <img src="images/rappel.png" alt="Bouton on vous rappelle gratuitement" />
          </div>
          <div className="jumbo-right">
            <p><span className="icon mail-open" /> Email</p>
            <span className="footer-mail"> <a href="mailto:info@koffi.be">info@koffi.be</a></span><br />
          </div>
        </div>
      </Box>
      <ContactFormPro />
    </Box>
  )
};

export default ContactPro;
